import { Component } from '@angular/core';
import { convertToISO } from 'app/core/shared/helper/date.helper';
import { isFormChange, onTypeChange } from 'app/core/shared/helper/equipment-registration.helper';
import { FormComponent } from 'app/modules/equipment-registration/component/form-component/form.component';
import { module } from 'app/modules/equipment-registration/equipment-registration.module';
import { Valve } from 'app/modules/equipment-registration/model/valve.model';
import { EquipRegistrationServices } from 'app/modules/equipment-registration/services/equipment-registration.service';

@Component({
  selector: 'app-king-wing-valve',
  templateUrl: './king-wing-valve.component.html',
  standalone: true,
  imports: [
    ...module,
    FormComponent
  ],
  styleUrls: ['./king-wing-valve.component.scss']
})
export class KingWingValveComponent {
  public equipmentRegistration$ = this.equipmentServices.equipmentRegistration$
  public kwvForm: Valve = new Valve()
  public tempKwvForm: Valve = new Valve()

  public isReplace: boolean = true;
  public disabledToggle: boolean = true;
  public wellStringId: string;

  constructor(
    private equipmentServices: EquipRegistrationServices
  ) { }

  ngOnInit() {
    this.initializeForm()

    this.equipmentRegistration$.subscribe(wellEquipment => {
      if (!wellEquipment) return '';

      this.wellStringId = wellEquipment.wellStringId

      if(wellEquipment?.kwValve){
        this.kwvForm = new Valve(wellEquipment?.kwValve);
      } else {
        this.initializeForm()
      }

      this.handleFormValue()
      this.isReplace = !wellEquipment?.kwValve;
      this.disabledToggle = !wellEquipment?.kwValve;
    })
  }

  private initializeForm(): void {
    this.kwvForm.reset()
  }

  private handleFormValue() {
    if (!this.kwvForm.mdSceValveTypeId) {
      this.setSceValveTypeId()
    }

    if (!this.kwvForm.sceXmasTreeId) {
      this.setXmasTreeId()
    }

    this.tempKwvForm = new Valve(this.kwvForm)
  }

  private setSceValveTypeId() {
    this.equipmentServices.getSceValveTypeId('KWV').subscribe(id => 
      {
        this.kwvForm.mdSceValveTypeId = this.tempKwvForm.mdSceValveTypeId = id
      })
  }

  private setXmasTreeId() {
    this.equipmentServices.getSceXmasTreeByStringId(this.wellStringId).subscribe(res => {
      if (res.data) {
        this.kwvForm.sceXmasTreeId = this.tempKwvForm.sceXmasTreeId = res.data.id
      }
    })
  }

  disabledSave(): boolean {
    return !this.kwvForm.mdSceValveTypeId || !this.kwvForm.sceXmasTreeId || isFormChange(this.kwvForm, this.tempKwvForm)
  }

  save() {
      onTypeChange(this.kwvForm)

    const operation = this.isReplace ?
      this.equipmentServices.addSceValve(this.kwvForm) :
      this.equipmentServices.updateSceValve(this.kwvForm);

    operation.subscribe((res) => {
      if (res) {
        this.equipmentServices.getEquipmentRegistration(this.wellStringId).subscribe();
      }
    });
  }
}
